<script setup lang="ts">
import useAppStore from '@/stores/app';
import { RouteLocationResolved } from 'vue-router';
import HeaderMenu from '@/layouts/main/header/components/HeaderMenu.vue';

// Instances
const appStore = useAppStore();
const router = useRouter();

// Data
const {branding} = storeToRefs(appStore);

// Computed
const homepage = computed<RouteLocationResolved>(() => router.resolve('/'));
</script>

<template>
    <header
        v-if="branding"
    >
        <div class="xl:giga-container">
            <div class="flex items-center justify-between">
                <RouterLink
                    v-if="branding.logo"
                    :to="homepage"
                    class="relative z-10 block shrink-0"
                >
                    <img
                        :src="branding.logo.src"
                        alt="Logo"
                        class="h-10"
                    />
                </RouterLink>

                <HeaderMenu/>
            </div>
        </div>
    </header>
</template>

<style scoped>

</style>
